import DesCreateTeamMainPanelViewModel from 'viewmodel/DesCreateTeamMainPanelViewModel';
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesCreateTeamMainPanel extends DesBaseCatalogAcc {
    constructor() {
        super(DesCreateTeamMainPanelViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }
    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'email-template-id', 'email-template-params', 'collaborationspaceid', 'locale'];
    }

}
if (!window.customElements.get('des-create-team-main-panel')) {
    window.customElements.define('des-create-team-main-panel', DesCreateTeamMainPanel);
}
